import { FunctionComponent } from 'preact';
import parseISO from 'date-fns/parseISO';
import format from 'date-fns/format';

const BuyingOptionsStock: FunctionComponent<BuyingOptionsStockProps> = ({
    stockLevel,
    stockDueDate,
    isSpecialKnitwear
}) => {
    // Show amber pips when stock level is less than 100.
    var stockIndicator = stockLevel < 100 ? 'amber' : 'green';
    const stockLevelSeparated = stockLevel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return (
        <span class="buying-options__stock">
            {isSpecialKnitwear ? (
                <span class="d-flex">
                    <i class="buying-options__stock-dot red" aria-hidden="true"></i>
                    <span>Made to Order</span>
                </span>
            ) : (
                <>
                    {' '}
                    <span class="d-flex">
                        <i
                            class={`buying-options__stock-dot ${stockIndicator}`}
                            aria-hidden="true"
                        ></i>
                        <span class="font-weight-bold mr-2">
                            {stockLevel <= 500 ? stockLevelSeparated : '500+'}
                        </span>
                        <span>in stock</span>
                    </span>
                    {stockDueDate && stockLevel < 100 ? (
                        <span>
                            <span class="mr-2">More on</span>
                            <span class="font-weight-bold">
                                {format(parseISO(stockDueDate), 'dd MMM')}
                            </span>
                        </span>
                    ) : null}
                </>
            )}
        </span>
    );
};

interface BuyingOptionsStockProps {
    stockLevel: number;
    stockDueDate: string | null;
    isSpecialKnitwear: boolean;
}

export default BuyingOptionsStock;
